"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useContext } from "react";
import CircleLoader from "@/components/distribution-plan-tool/common/CircleLoader";
import { AuthContext } from "@/components/auth/Auth";
import { ReactQueryWrapperContext } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiWave } from "@/generated/models/ApiWave";
import type { WaveGroupType } from "../WaveGroup.types";
import { useWaveGroupEditButtonsController, WaveGroupIdentitiesModal } from "./buttons/hooks/useWaveGroupEditButtonsController";
import WaveGroupEditMenu from "./buttons/subcomponents/WaveGroupEditMenu";
import WaveGroupManageIdentitiesModals from "./buttons/subcomponents/WaveGroupManageIdentitiesModals";
import { WaveGroupManageIdentitiesMode, type WaveGroupManageIdentitiesConfirmEvent } from "./WaveGroupManageIdentitiesModal";
interface WaveGroupEditButtonsProps {
  readonly haveGroup: boolean;
  readonly wave: ApiWave;
  readonly type: WaveGroupType;
}
export default function WaveGroupEditButtons(t0) {
  const $ = _c(32);
  const {
    haveGroup,
    wave,
    type
  } = t0;
  const {
    setToast,
    requestAuth,
    connectedProfile
  } = useContext(AuthContext);
  const {
    onWaveCreated
  } = useContext(ReactQueryWrapperContext);
  let t1;
  if ($[0] !== connectedProfile || $[1] !== haveGroup || $[2] !== onWaveCreated || $[3] !== requestAuth || $[4] !== setToast || $[5] !== type || $[6] !== wave) {
    t1 = {
      haveGroup,
      wave,
      type,
      connectedProfile,
      requestAuth,
      setToast,
      onWaveCreated
    };
    $[0] = connectedProfile;
    $[1] = haveGroup;
    $[2] = onWaveCreated;
    $[3] = requestAuth;
    $[4] = setToast;
    $[5] = type;
    $[6] = wave;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const {
    mutating,
    updateWave,
    canIncludeIdentity,
    canExcludeIdentity,
    canRemoveGroup,
    activeIdentitiesModal,
    openIdentitiesModal,
    closeIdentitiesModal,
    onIdentityConfirm
  } = useWaveGroupEditButtonsController(t1);
  let t2;
  if ($[8] !== onIdentityConfirm) {
    t2 = t3 => {
      const {
        identity,
        mode
      } = t3;
      const normalizedMode = mode === WaveGroupManageIdentitiesMode.INCLUDE ? WaveGroupIdentitiesModal.INCLUDE : WaveGroupIdentitiesModal.EXCLUDE;
      onIdentityConfirm({
        identity,
        mode: normalizedMode
      });
    };
    $[8] = onIdentityConfirm;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const handleIdentityConfirm = t2;
  let t3;
  if ($[10] !== openIdentitiesModal) {
    t3 = () => openIdentitiesModal(WaveGroupIdentitiesModal.INCLUDE);
    $[10] = openIdentitiesModal;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const handleIncludeIdentity = t3;
  let t4;
  if ($[12] !== openIdentitiesModal) {
    t4 = () => openIdentitiesModal(WaveGroupIdentitiesModal.EXCLUDE);
    $[12] = openIdentitiesModal;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const handleExcludeIdentity = t4;
  if (mutating) {
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <output aria-live="polite" className="tw-inline-flex tw-items-center tw-gap-2"><CircleLoader /><span className="tw-sr-only">Updating wave group identities</span></output>;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  let t5;
  if ($[15] !== canExcludeIdentity || $[16] !== canIncludeIdentity || $[17] !== canRemoveGroup || $[18] !== handleExcludeIdentity || $[19] !== handleIncludeIdentity || $[20] !== haveGroup || $[21] !== type || $[22] !== updateWave || $[23] !== wave) {
    t5 = <WaveGroupEditMenu wave={wave} type={type} onWaveUpdate={updateWave} hasGroup={haveGroup} canIncludeIdentity={canIncludeIdentity} canExcludeIdentity={canExcludeIdentity} canRemoveGroup={canRemoveGroup} onIncludeIdentity={handleIncludeIdentity} onExcludeIdentity={handleExcludeIdentity} />;
    $[15] = canExcludeIdentity;
    $[16] = canIncludeIdentity;
    $[17] = canRemoveGroup;
    $[18] = handleExcludeIdentity;
    $[19] = handleIncludeIdentity;
    $[20] = haveGroup;
    $[21] = type;
    $[22] = updateWave;
    $[23] = wave;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== activeIdentitiesModal || $[26] !== closeIdentitiesModal || $[27] !== handleIdentityConfirm) {
    t6 = <WaveGroupManageIdentitiesModals activeModal={activeIdentitiesModal} onClose={closeIdentitiesModal} onConfirm={handleIdentityConfirm} />;
    $[25] = activeIdentitiesModal;
    $[26] = closeIdentitiesModal;
    $[27] = handleIdentityConfirm;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== t5 || $[30] !== t6) {
    t7 = <>{t5}{t6}</>;
    $[29] = t5;
    $[30] = t6;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
}